import React from 'react';
import styles from './CustomSelector.less'
import arrowSvg from './images/arrow.svg'
// import {DownOutlined } from '@ant-design/icons';

// option [{label, value},...]
class CustomSelector extends React.Component {
  constructor(props) {
    super(props)
    this.options = props.options
    this.toggleOption = this.toggleOption.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.onChange = props.onChange
    this.state = {
      showOption: false,
      value: props.options[0] || {}
		}
  }

  toggleOption() {
    this.setState(
      {
        showOption: !this.state.showOption
      }
    )
  }

  selectCb(option) {    
    this.setState({
      showOption: false,
      value: option
    })
    this.onChange(option)
  }

  handleBlur(e) {
		// Not triggered when swapping focus between children,just triggered when focus left self
    if (!e.currentTarget.contains(e.relatedTarget)) {
      this.setState(
        {
          showOption: false
        }
      )
		}
	};

  render() {
    return (
      <div tabIndex={1} onBlur={this.handleBlur} className={styles['selector-wrapper']}>
        <div className={`${styles['select-box']} ${this.state.showOption && styles['focusing']}`} onClick={this.toggleOption}>
          <div className={`${styles['custom-select']} ${styles['ellipse-text']}`}>{this.state.value.label}</div>
          <img src={arrowSvg} alt="arrow" className={`${styles['arrow-icon']} ${this.state.showOption ? styles['arrow-up'] : ''}`}/>
			  </div>
			{this.state.showOption && (				
				<div className={styles['select-option']}>
					{
              this.options.map(option => <p key={option.value} className={`${styles['option-item']} ${styles['ellipse-text']}`} onClick={ () => this.selectCb(option) }>{option.label}</p>)
					}									
				</div>
					
			)}
		</div>
    )
  }
}

export default CustomSelector